import { all } from 'redux-saga/effects';
import appSaga from './app';
import userSaga from './user';
import faqSaga from './faq';
import onboardingSaga from './onboarding';
import mailboxSaga from './mailbox';
import authSaga from './auth';
import dashboardSaga from './dashboard';
import investmentsSaga from './investments';
import requestsSaga from './requests';
import depositsSaga from './deposits';
import estimatesSaga from './estimates';

export default function* rootsaga() {
  yield all([
    appSaga(),
    userSaga(),
    faqSaga(),
    onboardingSaga(),
    mailboxSaga(),
    authSaga(),
    dashboardSaga(),
    investmentsSaga(),
    requestsSaga(),
    depositsSaga(),
    estimatesSaga(),
  ]);
}
